const constants = {
  GET_COUNTRIES_PENDING: 'GET_COUNTRIES_PENDING',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_COUNTRIES_FAILURE: 'GET_COUNTRIES_FAILURE',
};

export default constants;
